import { render } from "./DomainsView.vue?vue&type=template&id=1b783f78"
import script from "./DomainsView.vue?vue&type=script&lang=js"
export * from "./DomainsView.vue?vue&type=script&lang=js"

import "./DomainsView.vue?vue&type=style&index=0&id=1b783f78&lang=css"

import exportComponent from "/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__